<template>
  <div>
    <v-card style="margin-bottom: 70px;">
      <v-card-title>
        <v-toolbar flat>
          <v-toolbar-title>Transações</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                dark
                color="primary"
                @click="$refs.filterDialog.toggle()"
                :disabled="!selectedClient.name"
                >mdi-magnify</v-icon
              >
            </template>
            <span>Filtrar</span>
          </v-tooltip>
        </v-toolbar>
      </v-card-title>
      <v-data-table
        v-infinite-scroll="getItems"
        infinite-scroll-disabled="busy"
        infinite-scroll-distance="10"
        :headers="headers"
        :items="items"
        :loading="loading"
        hide-default-footer
        single-expand
        show-expand
        :item-class="rowClass"
        :items-per-page.sync="items.length"
        class="elevation-1"
        style="font-weight: bold"
      >
        <v-progress-linear slot="progress" color="blue" indeterminate ></v-progress-linear>

        <template v-slot:item.createdAt="{ item }">{{
          new Date(item.createdAt).toLocaleDateString("pt-PT")
        }}</template>
        <template v-slot:item.currency="{ item }">{{
          showDefaultCurrency ? defaultCurrency : item.currency
        }}</template>

        <template v-slot:item.credit="{ item }">{{
          showDefaultCurrency
            ? (item.credit * item.currencyExchange).toFixed(2)
            : item.credit.toFixed(2)
        }}</template>

        <template v-slot:item.debit="{ item }">{{
          showDefaultCurrency
            ? (item.debit * item.currencyExchange).toFixed(2)
            : item.debit.toFixed(2)
        }}</template>

        <template
          v-slot:item.data-table-expand="{ item, expand, isExpanded }"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mx-0">
                <v-icon
                  v-on="on"
                  @click="handleExpandedItem(item, expand, isExpanded)"
                  color="blue"
                  >mdi-eye</v-icon
                >
              </v-btn>
            </template>
            <span>Ver Detalhes</span>
          </v-tooltip>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-data-table
              style="margin-top: 20px; margin-bottom: 20px; font-weight: normal"
              :headers="showTax ? headersLedgerLine : headersLedgerLineNoTax"
              :items="item.LedgerLines"
              hide-default-footer
              item-key="name"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title
                    >Detalhes Documento {{ item.externalId }}</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                  <v-switch
                    v-model="showTax"
                    label="Valores Com Impostos"
                  ></v-switch>
                </v-toolbar>
              </template>

              <template v-slot:item.costUnitWithTax="{ item }">{{
                showDefaultCurrency
                  ? (item.costUnitWithTax * item.currencyExchange).toFixed(2)
                  : item.costUnitWithTax.toFixed(2)
              }}</template>

              <template v-slot:item.totalWithTax="{ item }">{{
                showDefaultCurrency
                  ? (item.totalWithTax * item.currencyExchange).toFixed(2)
                  : item.totalWithTax.toFixed(2)
              }}</template>

              <template v-slot:item.costUnit="{ item }">{{
                showDefaultCurrency
                  ? (item.costUnit * item.currencyExchange).toFixed(2)
                  : item.costUnit.toFixed(2)
              }}</template>

              <template v-slot:item.total="{ item }">{{
                showDefaultCurrency
                  ? (item.total * item.currencyExchange).toFixed(2)
                  : item.total.toFixed(2)
              }}</template>

              <template v-slot.item.currency="{ item }">{{
                showDefaultCurrency ? defaultCurrency : item.currency
              }}</template>

              <template v-slot:body.append>
                <tr
                  :style="
                    expandedItem.globalDiscountPercentage ? `` : `display:none`
                  "
                >
                  <td
                    :colspan="headersLedgerLine.length"
                    style="font-weight: bold; border-top: 1px solid black"
                  >
                    <div style="text-align: center">
                      Desconto Global Percentagem:
                      {{ expandedItem.globalDiscountPercentage }}
                    </div>
                  </td>
                </tr>
                <tr
                  :style="
                    expandedItem.globalDiscountValue ? `` : `display:none`
                  "
                >
                  <td
                    :colspan="headersLedgerLine.length"
                    :style="
                      expandedItem.globalDiscountPercentage
                        ? `font-weight: bold;`
                        : `font-weight: bold;border-top: 1px solid black;`
                    "
                  >
                    <div style="text-align: center">
                      Desconto Global Valor:
                      {{ expandedItem.globalDiscountValue }}
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-data-table
              style="margin-top: 20px; margin-bottom: 20px; font-weight: normal"
              :headers="headersATD"
              :items="item.AccountTransDetails"
              hide-default-footer
              item-key="name"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title
                    >Detalhes Transações {{ item.externalId }}</v-toolbar-title
                  >
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>

              <template v-slot:item.payed="{ item }">{{
                showDefaultCurrency
                  ? (item.payed * item.currencyExchange).toFixed(2)
                  : item.payed.toFixed(2)
              }}</template>

              <template v-slot:item.currency="{ item }">{{
                showDefaultCurrency ? defaultCurrency : item.currency
              }}</template>
            </v-data-table>
          </td>
        </template>
      </v-data-table>
    </v-card>

    <filter-dialog
      ref="filterDialog"
      :addresses="addresses"
      :docTypes="docTypes"
      @doFilter="filter"
    />
  </div>
</template>

<script>
import FilterDialog from "./FilterDialog";
import infiniteScroll from "vue-infinite-scroll";
import ServiceLedger from "@/services/ServiceLedger";

export default {
  name: "ledger-data-table",
  props: ["selectedClient", "defaultCurrency", "addresses", "docTypes","showDefaultCurrency"],
  directives: {
    infiniteScroll,
  },
  components: {
    FilterDialog,
  },
  data() {
    return {
      showTax: true,
      page: 1,
      headers: [],
      headersClient: [
        { text: "Referência", value: "externalId", sortable: false },
        { text: "Documento", value: "docName", sortable: false },
        { text: "Cliente", value: "Client.name", sortable: false },
        { text: "Data", value: "createdAt", sortable: false },
        { text: "Vencimento", value: "dueDate", sortable: false },
        { text: "Débito", value: "debit", sortable: false },
        { text: "Crédito", value: "credit", sortable: false },
        { text: "Moeda", value: "currency", sortable: false },
        { text: "", value: "data-table-expand" },
      ],
      headersNoClient: [
        { text: "Referência", value: "externalId", sortable: false },
        { text: "Documento", value: "docName", sortable: false },
        { text: "Data", value: "createdAt", sortable: false },
        { text: "Vencimento", value: "dueDate", sortable: false },
        { text: "Débito", value: "debit", sortable: false },
        { text: "Crédito", value: "credit", sortable: false },
        { text: "Moeda", value: "currency", sortable: false },
        { text: "", value: "data-table-expand" },
      ],
      headersLedgerLine: [
        {
          text: "Referência",
          sortable: false,
          value: "externalId",
        },
        { text: "Descrição", sortable: false, value: "description" },
        { text: "Quantidade", sortable: false, value: "quantity" },
        { text: "Imposto", sortable: false, value: "taxDescription" },
        { text: "Custo UNI", sortable: false, value: "costUnitWithTax" },
        { text: "Desconto %", sortable: false, value: "discountPercentage" },
        { text: "Desconto Valor", sortable: false, value: "discountValue" },
        { text: "Total", sortable: false, value: "totalWithTax" },
        { text: "Moeda", sortable: false, value: "currency" },
      ],
      headersLedgerLineNoTax: [
        {
          text: "Referência",
          sortable: false,
          value: "externalId",
        },
        { text: "Descrição", sortable: false, value: "description" },
        { text: "Quantidade", sortable: false, value: "quantity" },
        { text: "Imposto", sortable: false, value: "taxDescription" },
        { text: "Custo UNI", sortable: false, value: "costUnit" },
        { text: "Desconto %", sortable: false, value: "discountPercentage" },
        { text: "Desconto Valor", sortable: false, value: "discountValue" },
        { text: "Total", sortable: false, value: "total" },
        { text: "Moeda", sortable: false, value: "currency" },
      ],
      headersATD: [
        { text: "Referência", value: "externalId", sortable: false },
        { text: "Valor", value: "payed", sortable: false },
        { text: "Moeda", value: "currency", sortable: false },
      ],
      expandedItem: {},
      items: [],
      busy: true,
      loading: false,
    };
  },
  methods: {
    setValues(items, showClient) {
      this.page = 2;
      this.items = [];
      this.items = this.items.concat(items);

      this.busy = false;

      if (showClient) {
        this.headers = this.headersClient;
      } else {
        this.headers = this.headersNoClient;
      }
    },
    handleExpandedItem(item, expand, isExpanded) {
      this.expandedItem = item;
      expand(!isExpanded);
    },
    async getItems() {
      try {
        this.busy = true;
        this.loading = true;

        let response;
        if (this.$store.state.user.level == 2) {
          response = await ServiceLedger.getLedgerAdmin(
            this.page,
            this.selectedClient.id,
            this.$refs.filterDialog.filters.addressId,
            this.$refs.filterDialog.filters.externalId,
            this.$refs.filterDialog.filters.startDate,
            this.$refs.filterDialog.filters.endDate,
            this.$refs.filterDialog.filters.showOnlyRedDocs,
            this.$refs.filterDialog.filters.docType,
            this.$refs.filterDialog.filters.orderDirection
          );
        }

        if (this.$store.state.user.level == 1) {
          response = await ServiceLedger.getLedgerSalesman(
            this.page,
            this.selectedClient.id,
            this.$refs.filterDialog.filters.addressId,
            this.$refs.filterDialog.filters.externalId,
            this.$refs.filterDialog.filters.startDate,
            this.$refs.filterDialog.filters.endDate,
            this.$refs.filterDialog.filters.showOnlyRedDocs,
            this.$refs.filterDialog.filters.docType,
            this.$refs.filterDialog.filters.orderDirection
          );
        }

        if (this.$store.state.user.level == 0) {
          response = await ServiceLedger.getLedger(
            this.page,
            this.$refs.filterDialog.filters.addressId,
            this.$refs.filterDialog.filters.externalId,
            this.$refs.filterDialog.filters.startDate,
            this.$refs.filterDialog.filters.endDate,
            this.$refs.filterDialog.filters.showOnlyRedDocs,
            this.$refs.filterDialog.filters.docType,
            this.$refs.filterDialog.filters.orderDirection
          );
        }

        this.items = this.items.concat(response.data);

        this.page++;
        this.busy = false;
        if (response.data.length == 0) {
          this.busy = true;
        }
        this.loading = false;
      } catch (error) {
        this.$store.dispatch("setSnackbar", {
          color: "error",
          text: error,
        });
        this.loading = false;
      }
    },
    filter() {
      this.items = [];
      this.page = 1;

      this.getItems();
    },
    rowClass(item) {
      if (item.balance != 0) {
        return "rowBad";
      }
    },
  },
};
</script>
<style>
.rowBad {
  background-color: rgba(255, 0, 0, 0.3);
}
</style>
